import { featuredCampaigns } from "@/mocks/campaigns";
import { buildWhatsAppLink } from "@/utils/whatsapp";
import Reveal from "./Reveal";
import SectionHeading from "./SectionHeading";

export default function Campaigns() {
  return (
    <section id="kampanyalar" className="ivory-canvas relative bg-background-50 py-16 md:py-24">
      <div className="mx-auto w-full max-w-7xl px-5 md:px-6">
        <Reveal>
          <SectionHeading
            eyebrow="Güncel Fırsatlar"
            title="Sonbahar Kampanyalarımız"
            description="Size uygun kampanyayı seçin, detayları öğrenmek ve randevu almak için WhatsApp üzerinden bize ulaşın."
          />
        </Reveal>

        <div className="mt-12 grid grid-cols-1 gap-6 md:gap-7 lg:grid-cols-3">
          {featuredCampaigns.map((campaign, index) => (
            <Reveal key={campaign.id} delay={index * 110} className="h-full">
              <article
                data-product-shop
                className="flex h-full flex-col overflow-hidden rounded-xl border border-background-300/70 bg-background-50 transition-transform duration-300 hover:-translate-y-1"
              >
                <div className="bg-primary-950">
                  <img
                    src={campaign.image}
                    alt={`${campaign.title} ${campaign.titleLine2} ${campaign.price} kampanya görseli`}
                    title={`${campaign.title} ${campaign.price} - Fatma Angay Güzellik Salonu`}
                    className="h-auto w-full"
                  />
                </div>

                <div className="flex flex-1 flex-col p-6 md:p-7">
                  <span className="font-label text-[0.62rem] font-semibold uppercase tracking-[0.26em] text-accent-700">
                    {campaign.badge}
                  </span>

                  <h3 className="mt-3 font-heading text-xl font-semibold uppercase leading-tight tracking-tight text-foreground-950 md:text-2xl">
                    {campaign.title}
                    <span className="mt-1 block text-base text-primary-600 md:text-lg">
                      {campaign.titleLine2}
                    </span>
                  </h3>

                  <div className="mt-5 flex items-end gap-2 border-t border-background-200 pt-5">
                    <span className="font-label text-[0.65rem] font-medium uppercase tracking-[0.22em] text-foreground-500">
                      {campaign.priceLabel}
                    </span>
                    <span className="ml-auto font-heading text-3xl font-semibold tracking-tight text-accent-700 md:text-[2.1rem]">
                      {campaign.price}
                    </span>
                  </div>

                  <p className="mt-4 font-body text-xs leading-relaxed text-foreground-600 md:text-sm">
                    {campaign.note}
                  </p>

                  <a
                    href={buildWhatsAppLink(campaign.message)}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="mt-6 inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-600 px-5 py-3.5 font-label text-xs font-semibold uppercase tracking-[0.14em] text-background-50 transition-colors hover:bg-primary-700"
                  >
                    <span className="flex h-4 w-4 items-center justify-center">
                      <i className="ri-whatsapp-line text-base" aria-hidden="true" />
                    </span>
                    {campaign.buttonLabel}
                  </a>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}